module.exports = __webpack_public_path__ + "img/1-6-6.936732b8.png";